(function ($) {
  $(document).ready(function () {
    
    //2020 Top Menu
    
    //Search box
    $('#header-search-link').click(function(e){
      	$('.header-search-item').toggleClass('active');
      	$('.mobile-nav-container').addClass('menu-close');
    });
    
    //Main Nav Mobile
    $(document).on('click', ".js-menu-toggle", function(e){
    	if (CorraUI.checkMediaQuery(900)) {
          	e.preventDefault();
          	$('header').toggleClass('menu-active');
          	$('.mobile-nav-container').toggleClass('menu-close');
          	$('.drop-panel').css('right', '-100vw');
          	$('.header-search-item').removeClass('active');
    	}
    });
    
    $(document).on('click', ".mobile-nav-container nav .has-sub-cats", function(e){
    	if (CorraUI.checkMediaQuery(900)) {
          	e.preventDefault();
        	$(this).closest('li').find('.drop-panel').css('right', '0');
    	}
    });
    
    // Mobile nav links back to main menu
    $(document).on('click', ".mobile-nav-container nav .mobile-cat-title a", function(e){
    	if (CorraUI.checkMediaQuery(900)) {
          	e.preventDefault();
        	$(this).closest('.drop-panel').css('right', '-100vw');
    	}
    });
    
    $(window).on("load resize", function () {
    	//Ensure mobile menu sits correctly
      	$('.mobile-nav-container').css('top', $('.main-header').height() + 'px');
      	$('.mobile-nav-container').addClass('menu-close');
      	$('header').removeClass('menu-active');
  	}).resize();
    
    //Country Selector
    $('#header-dropdown-country-selector').find("option").each(function () {
      	var e = $(this), t = e.attr("value");
    	e.prepend('<span aria-hidden="true" class="flag-pseudo flag-' + t.toLowerCase() + '"></span>');                                   
    });
    
    $('.country-locale').click(function(){
      if ( $('#country-dropdown-content').css('visibility') == 'hidden' )
        $('#country-dropdown-content').css('visibility','visible');
      else
        $('#country-dropdown-content').css('visibility','hidden');
    });
    
    $('#header_dropdown_country_selector_chosen button').click(
      function(event) {
        event.preventDefault();
      }
    );
    
    $('#header-dropdown-country-selector').chosen({width: "100%"});
    
    $('#country-dropdown-content .button-submit').click(
      function(event) {
        event.preventDefault();
        countryURL = $('#header-dropdown-country-selector').find(':selected').data('href');
        window.location.replace("https://" + countryURL);
      }
    );
    
    $( ".header-row-secondary" ).on('mouseover', function () {
      $('#country-dropdown-content').css('visibility','hidden');
      $('#header-dropdown-country-selector').trigger('chosen:close');
    });
    
  });
})(jQuery);